import React, { useId } from "react";
import styles from "./ImageUploader.module.scss";
import close from "../../../images/icons/AdminPanel/close.svg";
import upload from "../../../images/icons/AdminPanel/sim_card_download.svg";

interface ImageProps {
  image: string | null; // Текущее изображение (может быть null, если изображение не загружено)
  setImage: (value: string | null) => void; // Функция для обновления изображения
  handleImageRemove: () => void; // Функция для удаления изображения
}

const AvatarUploader: React.FC<ImageProps> = ({
  image,
  setImage,
  handleImageRemove,
}) => {
  const id = useId();

  // Обработчик загрузки изображения
  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const file = files[0]; // Берем первый файл
      const reader = new FileReader();

      reader.onloadend = () => {
        if (reader.result) {
          setImage(reader.result as string); // Устанавливаем новое изображение
        }
      };

      reader.onerror = () => {
        console.error("Failed to read file");
      };

      reader.readAsDataURL(file); // Преобразуем файл в Base64
    }
  };

  return (
    <div className={styles.container}>
      {/* Поле для загрузки изображения */}
      <label htmlFor={id} className={styles.conteinerLabel}>
        <input
          id={id}
          type="file"
          accept="image/*"
          onChange={handleImageUpload}
          className={styles.inputImages}
          placeholder="Datei auswählen"
        />
        <img src={upload} alt="Icon upload" />
        <p className={styles.conteinerLabel_text}>
          Klicken Sie in diesen Bereich, um die Datei herunterzuladen
        </p>
      </label>

      {/* Отображение текущего изображения */}
      {image && (
        <div className={styles.imageWrapper}>
          <img
            src={close}
            alt="Icon"
            className={styles.removeButton}
            onClick={handleImageRemove} // Удаляем изображение
          />
          <img src={image} alt="Photo" className={styles.image} />
        </div>
      )}
    </div>
  );
};

export default AvatarUploader;
